import { gql } from "@medbillai/generated-graphql-types";

export const linksQuery = gql(/* GraphQL */ `
  query GetInsuranceLinks {
    me {
      id
      flexpaLinks {
        id
        active
        createdAt
        lastSyncedAt
        patientName
        patientDOB
        deactivatedReason
        endpoint {
          displayName
          id
          slug
          isActive
          organization {
            __typename
            id
            displayName
            slug
          }
        }
      }
      webAgentLinks {
        __typename
        id
        active
        createdAt
        lastSyncedAt
        patientName
        patientId
        patientDOB
        latestExecution {
            id
            ingestions {
              id
              startedAt
              endedAt
              status
              resources {
                id
            } 
          }
        }
        executions(order: { createdAt: { dir: DESC } }) {
          id
          createdAt
          ingestions(filter: { status: { in: [COMPLETED, PARTIAL] } }, order: { startedAt: { dir: DESC } }, first: 1) {
            id
            startedAt
            endedAt
            status
          }
        }
        deactivatedAt
        deactivatedReason
        endpoint {
          __typename
          displayName
          id
          slug
          isActive
          organization {
            __typename
            id
            displayName
            slug
          }
        }
      }
    }
  }
`);
/**
 * Important! getWebAgentEndpointsP012Query and getWebAgentEndpointsAllQuery
 * queries should be updated together since we interchange them based on a
 * feature flag.
 */
export const getWebAgentEndpointsP012Query = gql(/* GraphQL */ `
  query GetWebAgentEndpointsP012 {
    webAgent__Endpoint(
      filter: {
        and: [
          { isActive: { eq: true } }
          { currentSupportLevel: { supportLevel: { in: [P0, P1, P2] } } }
        ]
      }
    ) {
      isActive
      __typename
      id
      type
      displayName
      displayUrl
      slug
      loginUrl
      portalGuideUrl
      currentSupportLevel {
        supportLevel
      }
      metadata
      organization {
        id
        displayName
        slug
      }
    }
  }
`);

export const getWebAgentEndpointsAllQuery = gql(/* GraphQL */ `
  query GetWebAgentEndpointsAll {
    webAgent__Endpoint(filter: { isActive: { eq: true } }) {
      __typename
      id
      type
      isActive
      displayName
      displayUrl
      slug
      loginUrl
      metadata
      portalGuideUrl
      currentSupportLevel {
        supportLevel
      }
      organization {
        id
        displayName
        slug
      }
    }
  }
`);
